<div class="sidenav-content" cdkScrollable *ngIf="!submitting; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register' | translate) + getLongType()">
		<button type="button" mat-flat-button (click)="saveGuarantee($event, true)">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button type="submit" mat-flat-button color="primary" (click)="goToNextStep($event)">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<form>
		<div class="copo-form-container copo-grid">
			<copo-stepper class="copo-stepper-container" [steps]="steps" (stepClicked)="onStepClicked($event)">
			</copo-stepper>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 #constructionSiteTitle translate>guarantee.construction.site</h2>
				</div>
			</div>
			<div class="copo-grid-row copo-grid-row-stretch">
				<div class="copo-grid-row-column">
					<div class=" copo-outline-label" translate>guarantee.address</div>
					<mat-form-field class="outline-comment" appearance="outline">
						<textarea rows="3" class="textarea-no-resize" type="textarea" maxlength="255" cdkTextareaAutosize
							(change)="addressChanged($event)"
							[formControl]="addressFormControl" matInput spellcheck="false"
							autocomplete="off">
						</textarea>
						<mat-hint align="end">{{addressFormControl.value.length || 0}}/255</mat-hint>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row-column">
				<div class="copo-grid-row-radio">
					<mat-error *ngIf="onErrorConstructionSite" class="copo-coordinates-error">
						<span translate>guarantee.construction.site.mandatory</span>
					</mat-error>
				</div>
				<div class="copo-grid-row-radio">
					<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
						(change)="coordinateChange($event)">
						<mat-radio-button class="copo-grid-row-column copo-coordinates-radio" value="dd" checked="checked">
							<span translate>guarantee.coordinates.decimal</span>
						</mat-radio-button>
						<mat-radio-button class="copo-grid-row-column copo-coordinates-radio" value="dms">
							<span translate>guarantee.coordinates.dms</span>
						</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<div class="copo-grid-row" *ngIf="onErrorCoordinates">
				<div class="copo-grid-row-column">
					<mat-error class="copo-coordinates-error">
						<span translate>guarantee.coordinates.pair.mandatory</span>
					</mat-error>
				</div>
			</div>
			<div class="copo-grid-row grid-template-columns"
				[ngClass]=" latitudeSecondsFormControl.hasError('pattern') ? 'copo-latspace' : 'copo-defaultspace'">
				<ng-container *ngIf="coordinatedd">
					<div class="copo-grid-row-column" #latitudeDiv>
						<mat-form-field class="copo-coordinate-field">
							<mat-label translate>guarantee.latitude</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="90" min="-90"
								[formControl]="latitudeFormControl" (change)="latitudeChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
							</mat-icon>
							<mat-error>
								<span *ngIf="latitudeFormControl.hasError('max') || latitudeFormControl.hasError('min')"
									translate>
									guarantee.lat.max
								</span>
								<span *ngIf="latitudeFormControl.hasError('pattern')
												&& (latitudeFormControl.hasError('max')
												|| latitudeFormControl.hasError('min'))">
									,&nbsp;
								</span>
								<span *ngIf="latitudeFormControl.hasError('pattern')" translate>
									guarantee.latlong.degree.pattern
								</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column" #longitudeDiv>
						<mat-form-field class="copo-coordinate-field">
							<mat-label translate>guarantee.longitude</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="180" min="-180"
								[formControl]="longitudeFormControl" (change)="longitudeChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
							</mat-icon>
							<mat-error>
								<span *ngIf="longitudeFormControl.hasError('max')
												|| longitudeFormControl.hasError('min')" translate>
									guarantee.long.max
								</span>
								<span *ngIf="longitudeFormControl.hasError('pattern')
												&& (longitudeFormControl.hasError('max')
												|| longitudeFormControl.hasError('min'))">
									,&nbsp;
								</span>
								<span *ngIf="longitudeFormControl.hasError('pattern')" translate>
									guarantee.latlong.degree.pattern
								</span>
							</mat-error>
						</mat-form-field>
					</div>
				</ng-container>
				<ng-container *ngIf="coordinatedms">
					<div class="copo-grid-row-column">
						<mat-form-field class="field-size" #latDegreeDiv>
							<mat-label translate>guarantee.lat.degrees</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="89" min="0"
								[formControl]="latitudeDegreeFormControl" (change)="dmsValueChange()">
							<mat-error *ngIf="!latitudeDegreeFormControl.valid"><span
									translate>guarantee.lat.degree</span></mat-error>
						</mat-form-field>
						&thinsp;°&thinsp;
						<mat-form-field class="field-size" #latMinutesDiv>
							<mat-label translate>guarantee.lat.minutes</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="59" min="0"
								[formControl]="latitudeMinutesFormControl" (change)="dmsValueChange()">
							<mat-error *ngIf="!latitudeMinutesFormControl.valid">
								<span translate>guarantee.latlongmin.max</span>
							</mat-error>
						</mat-form-field>
						&thinsp;'&thinsp;
						<mat-form-field class="field-size" #latSecondsDiv>
							<mat-label translate>guarantee.lat.seconds</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="59.9999" min="0"
								pattern="^-?\d*[,.]?\d{0,4}$" [formControl]="latitudeSecondsFormControl" (change)="dmsValueChange()">
							<mat-error *ngIf="latitudeSecondsFormControl.hasError('pattern')">
								<span translate>guarantee.latlongsec.pattern</span>
							</mat-error>
							<mat-error *ngIf="latitudeSecondsFormControl.hasError('max')">
								<span translate>guarantee.latlongsec.max</span>
							</mat-error>
							<mat-error *ngIf="latitudeSecondsFormControl.hasError('min')">
								<span translate>guarantee.latlongsec.max</span>
							</mat-error>
						</mat-form-field>
						&thinsp;''&thinsp;
						<mat-form-field class="field-select-size">
							<mat-select [formControl]="latitudeDirectionFormControl" (selectionChange)="dmsValueChange()">

								<mat-option *ngFor="let latitudeType of latitudeTypeValues" [value]="latitudeType.key">
									{{latitudeType.value.label | translate }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column">
						<mat-form-field class="field-size" #longDegreeDiv>
							<mat-label translate>guarantee.long.degrees</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="179" min="0"
								[formControl]="longitudeDegreeFormControl" (change)="dmsValueChange()">
							<mat-error *ngIf="!longitudeDegreeFormControl.valid">
								<span translate>guarantee.longdegress.max</span>
							</mat-error>
						</mat-form-field>
						&thinsp;°&thinsp;
						<mat-form-field class="field-size" #longMinutesDiv>
							<mat-label translate>guarantee.long.minutes</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="59" min="0"
								[formControl]="longitudeMinutesFormControl" (change)="dmsValueChange()">
							<mat-error *ngIf="!longitudeMinutesFormControl.valid"><span
									translate>guarantee.latlongmin.max</span>
							</mat-error>
						</mat-form-field>
						&thinsp;'&thinsp;
						<mat-form-field class="field-size" #longSecondsDiv>
							<mat-label translate>guarantee.long.seconds</mat-label>
							<input type="number" matInput spellcheck="false" autocomplete="off" max="59.9999" min="0"
								pattern="^-?\d*[,.]?\d{0,4}$" [formControl]="longitudeSecondsFormControl" (change)="dmsValueChange()">
							<mat-error *ngIf="longitudeSecondsFormControl.hasError('pattern')">
								<span translate>guarantee.latlongsec.pattern</span>
							</mat-error>
							<mat-error *ngIf="longitudeSecondsFormControl.hasError('max')">
								<span translate>guarantee.latlongsec.max</span>
							</mat-error>
							<mat-error *ngIf="longitudeSecondsFormControl.hasError('min')">
								<span translate>guarantee.latlongsec.max</span>
							</mat-error>
						</mat-form-field>
						&thinsp;''&thinsp;
						<mat-form-field class="field-select-size">
							<mat-select [formControl]="longitudeDirectionFormControl" (selectionChange)="dmsValueChange()">
								<mat-option *ngFor="let longitudeType of longitudeTypeValues"
									[value]="longitudeType.key">
									{{longitudeType.value.label | translate }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</ng-container>
			</div>
			<ng-container *ngIf="guarantee.applicationType === 'Organic Coating'">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<h2 translate>guarantee.building.altitude</h2>
					</div>
				</div>
				<div class="copo-grid-row align-bottom-altitude">
					<div class="copo-grid-row-column">
						<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
							(change)="buildingEnvAltitudeCheckboxChange($event.checked)" [formControl]="buildingEnvAltitudeFormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.altitude.above.900m</span>
						</mat-checkbox>
					</div>
				</div>
			</ng-container>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.location</h2>
				</div>
			</div>
			<ng-container *ngIf="guarantee.applicationType !== 'Organic Coating'">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
							(change)="onRuralAreaCheckboxChange($event.checked)" [formControl]="ruralAreaFormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.rural.area</span>
						</mat-checkbox>
						<ng-container *ngIf="ruralAreaFormControl.value === true">
							<div class="copo-grid-row-radio">
								<div class="copo-grid-row-column">
									<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
										(change)="onProximityCheckboxChange($event.checked)"
										[formControl]="proximityFormControl">
										<span class="checkbox-label-wrapped" translate>guarantee.proximity.buildings</span>
									</mat-checkbox>
									<ng-container *ngIf="proximityFormControl.value === true">
										<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
											<mat-form-field>
												<mat-label translate>guarantee.distance.site</mat-label>
												<input type="text" matInput copoInputNumber spellcheck="false"
													autocomplete="off" maxlength="5"
													[formControl]="distanceFromSiteFormControl"
													(change)="distanceFromSiteChanged($event)">
												<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
													class="image-draft-list-icon"></mat-icon>
											</mat-form-field>
										</div>
									</ng-container>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="guarantee.applicationType === 'Organic Coating'">
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
							(change)="onRuralArea20KMCheckboxChange($event.checked)" [formControl]="ruralArea20KMFormControl">
							<span class="checkbox-label-wrapped" translate>guarantee.rural.area.20KM</span>
						</mat-checkbox>
						<ng-container *ngIf="ruralArea20KMFormControl.value === true">
							<div class="copo-grid-row-radio">
								<div class="copo-grid-row-column">
									<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
										(change)="onProximityCheckboxChange($event.checked)"
										[formControl]="proximityFormControl">
										<span class="checkbox-label-wrapped" translate>guarantee.proximity.buildings</span>
									</mat-checkbox>
									<ng-container *ngIf="proximityFormControl.value === true">
										<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
											<mat-form-field>
												<mat-label translate>guarantee.distance.site</mat-label>
												<input type="text" matInput copoInputNumber spellcheck="false"
													autocomplete="off" maxlength="5"
													[formControl]="distanceFromSiteFormControl"
													(change)="distanceFromSiteChanged($event)">
												<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
													class="image-draft-list-icon"></mat-icon>
											</mat-form-field>
										</div>
									</ng-container>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
						(change)="onUrbanAgglomerationCheckboxChange($event.checked)"
						[formControl]="urbanAgglomerationFormControl">
						<span class="checkbox-label-wrapped" translate>guarantee.urban.agglomeration</span>
					</mat-checkbox>
					<ng-container *ngIf="urbanAgglomerationFormControl.value === true">
						<div class="copo-grid-row">
							<div class="copo-grid-row-column">
								<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
									(change)="onMainlyRefinerieCheckboxChange($event.checked)"
									[formControl]="mainlyRefinerieFormControl">
									<span class="checkbox-label-wrapped" translate>guarantee.refineries.factories</span>
								</mat-checkbox>
								<ng-container *ngIf="mainlyRefinerieFormControl.value === true">
									<div class="copo-grid-row-refinery  grid-template-columns">
										<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
											<mat-form-field>
												<mat-label translate>guarantee.distance.site</mat-label>
												<input type="text" matInput copoInputNumber spellcheck="false"
													autocomplete="off" maxlength="5"
													[formControl]="hazardousIndustryDistanceFormControl"
													(change)="hazardousIndustryDistanceChanged($event)">
												<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
													class="image-draft-list-icon"></mat-icon>
											</mat-form-field>
										</div>
										<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
											<mat-form-field>
												<mat-label translate>guarantee.industry.type</mat-label>
												<input type="text" matInput spellcheck="false" autocomplete="off"
													maxlength="20" [formControl]="industryTypeFormControl"
													(change)="industryTypeChanged($event)">
												<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
													class="image-draft-list-icon"></mat-icon>
											</mat-form-field>
										</div>
										<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
											<mat-form-field>
												<mat-label translate>guarantee.emission.type</mat-label>
												<input type="text" matInput spellcheck="false" autocomplete="off"
													maxlength="20" [formControl]="emissionsTypeFormControl"
													(change)="emissionsTypeChanged($event)">
												<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
													class="image-draft-list-icon"></mat-icon>
											</mat-form-field>
										</div>
									</div>
									<div class="copo-grid-container" *ngIf="guarantee.applicationType === 'Magnelis-Solar' 
									|| guarantee.applicationType === 'Magnelis-Other application' 
									|| guarantee.applicationType === 'Magnelis-Building'">
										<span class="copo-grid-column" translate>guarantee.prevailing.wind</span>
										<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
											[formControl]="gasCarriedWindsFormControl"
											(change)="onGasCarriedWindsChange($event)">
											<mat-radio-button class="copo-guarantee-radio" value="true">
												<span translate>guarantee.radio.yes</span>
											</mat-radio-button>
											<mat-radio-button class="copo-guarantee-radio" value="false">
												<span translate>guarantee.radio.no</span>
											</mat-radio-button>
										</mat-radio-group>
									</div>
									<div class="copo-grid-container" *ngIf="guarantee.applicationType === 'Organic Coating'">
										<span class="copo-grid-column" translate>guarantee.prevailing.wind</span>
										<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
											[formControl]="gasCarriedWindsFormControl"
											(change)="onGasCarriedWindsChange($event)">
											<mat-radio-button class="copo-guarantee-radio" value="true">
												<span translate>guarantee.radio.yes</span>
											</mat-radio-button>
											<mat-radio-button class="copo-guarantee-radio" value="false">
												<span translate>guarantee.radio.no</span>
											</mat-radio-button>
											<mat-radio-button class="copo-guarantee-radio" value="">
												<span translate>guarantee.radio.na</span>
											</mat-radio-button>
										</mat-radio-group>
									</div>
								</ng-container>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
						(change)="onDesertCheckboxChange($event.checked)" [formControl]="desertFormControl">
						<span class="checkbox-label-wrapped" translate>guarantee.desert</span>
					</mat-checkbox>
					<ng-container *ngIf="desertFormControl.value === true">
						<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
							<mat-form-field>
								<mat-label translate>guarantee.area</mat-label>
								<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
									[formControl]="areaNameFormControl" (change)="areaNameChanged($event)">
								<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
								</mat-icon>
							</mat-form-field>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
						(change)="onCoastalOrMarineCheckboxChange($event.checked)"
						[formControl]="coastalOrMarineFormControl">
						<span class="checkbox-label-wrapped" translate>guarantee.coastal.marine</span>
					</mat-checkbox>
					<ng-container *ngIf="coastalOrMarineFormControl.value === true">
						<div class="copo-grid-row ">
							<div class="copo-grid-row-column-check">
								<ng-container *ngIf="guarantee.applicationType !== 'Organic Coating'">
									<mat-label translate>guarantee.distance.seafront</mat-label>
								</ng-container>
								<div class="copo-grid-row-column" *ngIf="guarantee.applicationType === 'Magnelis-Other application' 
								|| guarantee.applicationType === 'Magnelis-Building'">
									<mat-form-field>
										<mat-label translate>guarantee.distance.seafrontkm</mat-label>
										<input type="text" matInput copoInputNumber spellcheck="false"
											autocomplete="off" maxlength="5" [formControl]="distanceToSeaFormControl"
											(change)="distanceToSeaChanged($event)">
										<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
											class="image-draft-list-icon"></mat-icon>
									</mat-form-field>
								</div>
								<ng-container *ngIf="guarantee.applicationType === 'Organic Coating'">
									<div class="copo-grid-row-column">
										<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
											(change)="distanceToSeaCheckChanged($event.checked)"
											[formControl]="distanceToSeaCheckFormControl">
											<span class="checkbox-label-wrapped" translate>guarantee.distance.3KM.seafront</span>
										</mat-checkbox>
										<ng-container *ngIf="distanceToSeaCheckFormControl.value === true">
											<div class="copo-grid-row">
												<div class="copo-grid-row-column">
													<mat-form-field>
														<mat-label translate>guarantee.distance.seafrontkm</mat-label>
														<input type="text" matInput copoInputNumber spellcheck="false"
															autocomplete="off" maxlength="5" [formControl]="specifyDistanceToSeaFormControl"
															(change)="specifyDistanceToSeaChanged($event)">
														<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
															class="image-draft-list-icon"></mat-icon>
													</mat-form-field>
												</div>
											</div>
										</ng-container>
									</div>
								</ng-container>
								<div class="copo-grid-row-column">
									<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
										(change)="onCoastCheckboxChange($event.checked)"
										[formControl]="coastFormControl">
										<span class="checkbox-label-wrapped" translate>guarantee.distance.less than
											300m</span>
									</mat-checkbox>
									<ng-container *ngIf="coastFormControl.value === true">
										<div class="copo-grid-row-column">
											<mat-checkbox class="copo-guarantee-checkbox-placement"
												labelPosition="after"
												(change)="onDirectWettingCheckboxChange($event.checked)"
												[formControl]="directWettingFormControl">
												<span class="checkbox-label-wrapped"
													translate>guarantee.without.direct.wetting </span>
											</mat-checkbox>
										</div>
										<div class="copo-grid-row-column">
											<mat-checkbox class="copo-guarantee-checkbox-placement"
												labelPosition="after"
												(change)="onPartialOrMomentaryCheckboxChange($event.checked)"
												[formControl]="partialOrMomentaryFormControl">
												<span class="checkbox-label-wrapped"
													translate>guarantee.with.partial.momentary.wetting</span>
											</mat-checkbox>
										</div>
									</ng-container>
								</div>
								<div *ngIf="guarantee.applicationType === 'Magnelis-Solar'">
									<div class="copo-grid-row-column">
										<mat-checkbox class="copo-guarantee-checkbox-placement"
											labelPosition="after"
											(change)="onBetweenTwoCheckboxChange($event.checked)"
											[formControl]="betweenTwoFormControl">
											<span class="checkbox-label-wrapped" translate>guarantee.between.300mand2km
											</span>
										</mat-checkbox>
									</div>
									<div class="copo-grid-row-column">
										<mat-checkbox class="copo-guarantee-checkbox-placement"
											labelPosition="after"
											(change)="onBetweenTenCheckboxChange($event.checked)"
											[formControl]="betweenTenFormControl">
											<span class="checkbox-label-wrapped"
												translate>guarantee.between.2kmand10km</span>
										</mat-checkbox>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<mat-checkbox class="copo-guarantee-checkbox-placement" labelPosition="after"
						(change)="onSpecificEnvironmentCheckboxChange($event.checked)"
						[formControl]="specificEnvironmentFormControl">
						<span class="checkbox-label-wrapped" translate>guarantee.specific.environment</span>
					</mat-checkbox>
					<ng-container *ngIf="specificEnvironmentFormControl.value === true">
						<div class="copo-grid-row-column copo-guarantee-checkbox-placement">
							<mat-form-field>
								<mat-label translate>guarantee.distance.lake</mat-label>
								<input type="text" matInput copoInputNumber spellcheck="false" autocomplete="off"
									maxlength="5" [formControl]="distanceToLakeFormControl"
									(change)="distanceToLakeChanged($event)">
								<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
								</mat-icon>
							</mat-form-field>
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</form>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>